module.exports = __webpack_public_path__ + "static/media/ic-dashboard.c3e5cc9d.svg";